import React from 'react';
import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import SpoofPreventionList from 'components/SpoofPreventionList/SpoofPreventionList';

const style = {
	validationError: {
		fontSize: '12px',
		fontWeight: '300',
		color: '#e3161b',
	},
	invalid: {
		color: '#e3161b',
	},
	stepContent: {
		marginTop: '-60px',
	},
	tableHeader: {
		position: 'absolute',
		top: '125px',
		fontSize: '18px',
		fontWeight: 'lighter',
	},
};

class AddContactCenterStepTwo extends React.Component {
	state = {
		spoofPreventionList: [],
		isStepValid: true,
	};

	sendState() {
		return this.state.spoofPreventionList;
	}

	onPhoneNumbersListChange = (list) => {
		this.setState({
			spoofPreventionList: list,
			isStepValid: list?.length > 0,
		});
	}

	isValidated() {
		const isStepValid = this.state.spoofPreventionList?.length
		this.setState({
			isStepValid,
		});
		return isStepValid;
	}

	render() {
		const { classes } = this.props;
		const isStepValid = this.state.isStepValid;

		return (
			<GridContainer justify="center" className={classes.stepContent}>
				<GridItem xs={12} sm={12} md={12}>
					<div className={`${classes.tableHeader} ${!isStepValid ? classes.invalid : ''}`}>
						<div>
							Spoof Prevention List *
						</div>
						{!isStepValid &&
							<div className={classes.validationError}>
								At least one phone number is required
						</div>
						}
					</div>

					<SpoofPreventionList
						title=""
						callCenterCreation
						isFrontEndData
						parentContactCenter={this.state.contactCenter}
						data={this.state.spoofPreventionList}
						onPhoneNumbersListChange={this.onPhoneNumbersListChange}
					/>
				</GridItem>
			</GridContainer>
		);
	}
}

AddContactCenterStepTwo.propTypes = {
	allStates: PropTypes.object,
	classes: PropTypes.object,
};

export default withStyles(style)(AddContactCenterStepTwo);
